<template>
  <div class="query-home-wrap">
    <my-header
        :current-title="['发票业务', '发票查询统计']"
        main-title="发票查询统计"
        @back="emit('go-invoice')"
    />

    <div class="content-box">
      <div class="main-box">
        <h3>发票查询统计</h3>

        <div class="menu-wrap">
          <div
              v-for="(item,idx) in menuList"
              :key="idx"
              @click="clickMenu(item)"
              class="menu-item">
            <img class="icon" :src="item.icon"/>
            <div class="content">
              <h3>{{ item.label }}</h3>
              <span class="desc">{{ item.desc }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footer class="footer">
      <img src="https://static.rhkj.com/renhe_fe/other/333.png">
    </footer>
  </div>
</template>

<script setup>
import myHeader from "../cmp/myHeader.vue";


const emit = defineEmits(['go-invoice', 'switchPage']);

const menuList = ref([
  {
    icon: 'https://static.rhkj.com/renhe_fe/other/300.svg',
    label: '全量发票查询',
    desc: '查询纳税人开具、取得、经办的发票和海关缴款书信息',
    key: 'fullInvoiceQuery',
  },
  {
    icon: 'https://static.rhkj.com/renhe_fe/other/301.svg',
    label: '开票数据统计及发票领用查询',
    desc: '查询纳税人各种发票领用存及销项金额、税额等统计资料',
    key: 'statistUseQuery',
  },
  {
    icon: 'https://static.rhkj.com/renhe_fe/other/302.svg',
    label: '历史抵扣信息查询',
    desc: '查询多个历史税款所属期抵扣统计确认信息',
  },
  {
    icon: 'https://static.rhkj.com/renhe_fe/other/303.svg',
    label: '未到勾选日期发票查询',
    desc: '查询各类可抵扣勾选发票和海关缴款书信息',
  },
  {
    icon: 'https://static.rhkj.com/renhe_fe/other/304.svg',
    label: '进项税额转出情况查询',
    desc: '查询应做进项转出的发票和海关缴款书及红字发票信息确认单信息',
  },
  {
    icon: 'https://static.rhkj.com/renhe_fe/other/305.svg',
    label: '批量导入导出进度查询',
    desc: '查询批量数据处理任务的状态及结果',
  },
  {
    icon: 'https://static.rhkj.com/renhe_fe/other/306.svg',
    label: '汇总纳税分支机构开票数据查询',
    desc: '对汇总缴纳增值税的总分机构汇总分支机构开票数据查询',
  },
  {
    icon: 'https://static.rhkj.com/renhe_fe/other/307.svg',
    label: '出口转内销发票查询',
    desc: '查询各类可抵扣勾选出口转内销发票和海关缴款书信息',
  },
])

function clickMenu(item) {
  if (!item.key) {
    return
  }
  emit('switchPage', {key: item.key})
}
</script>


<style scoped lang="scss">
.query-home-wrap {
  height: 100vh;
  overflow-y: auto;

  .content-box {
    padding-top: 24px;
    background-color: rgb(238, 238, 238);
    min-height: calc(100vh - 136px - 152px - 5px);

    .main-box {
      background-color: #FFFFFF;
      padding: 24px;
      margin: 0 24px 0 24px;

      > h3 {
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        border-bottom: 1px solid rgba(39, 40, 46, .08);
        padding-bottom: 24px;
        margin-bottom: 24px;
      }

      .menu-wrap {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        margin-top: -30px;
        margin-left: -20px;

        .menu-item {
          cursor: pointer;
          display: flex;
          width: calc(calc(100% - 70px) / 3);
          box-sizing: border-box;
          margin-left: 20px;
          margin-top: 30px;
          padding: 24px 24px 34px 24px;
          border: 1px solid rgba(39, 40, 46, .08);

          &:hover {
            box-shadow: 0 4px 10px 0 rgba(17, 31, 138, .1);
          }

          .icon {
            width: 48px;
            height: 48px;
            display: block;
            padding-top: 10px;
          }

          .content {
            margin-left: 16px;

            > h3 {
              color: #333333;
              font-size: 15px;
              font-weight: 700;
              line-height: 22px;
              letter-spacing: 0;
            }

            span.desc {
              font-size: 12px;
              line-height: 20px;
              letter-spacing: 0;
              color: #666;
            }
          }

        }
      }

    }
  }

  .footer {
    background-color: rgb(238, 238, 238);
    display: flex;
    justify-content: center;
    padding: 30px 0;
    opacity: 0.9;
  }
}

@media (min-width: 1500px) {
  .query-home-wrap {
    .content-box {
      .main-box {
        .menu-wrap .menu-item {
          width: calc(calc(100% - 90px) / 4);
        }
      }
    }
  }
}

@media (min-width: 1960px) {
  .query-home-wrap {
    .content-box {
      .main-box {
        .menu-wrap .menu-item {
          width: calc(calc(100% - 110px) / 5);
        }
      }
    }
  }
}
</style>
